<template>
  <transition name="fade">
    <div v-if="visible" class="avatar-preview">
      <div class="avatar-wrapper" :title="titleText">
        <div class="avatar-background" :style="{ background: bgGradient }" />

        <Avatar
          v-if="hasAvatar"
          v-bind="avatarProps"
          class="avatar-component"
        />
        <div
          v-else
          class="avatar-silhouette"
          role="img"
          :aria-label="titleText"
        >
          <!-- Простой SVG силуэт (голова + плечи) -->
          <svg viewBox="0 0 200 200" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="false">
            <!-- плечи / туловище -->
            <path d="M40 150 C40 115,160 115,160 150 L160 160 L40 160 Z" />
            <!-- голова -->
            <circle cx="100" cy="70" r="34" />
          </svg>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue';
import { Avatar, Factory } from 'vue3-avataaars';

const props = defineProps({
  // Теперь по умолчанию null — если родитель явно передаёт null, будет силуэт
  avatarData: {
    type: Object,
    default: null
  },
  visible: { type: Boolean, default: false }
});

const emit = defineEmits(['select', 'update:visible', 'close']);

const hasAvatar = computed(() => props.avatarData !== null && props.avatarData !== undefined);

const avatarProps = computed(() => {
  return hasAvatar.value ? ({ ...Factory(), ...props.avatarData }) : Factory();
});

const bgGradient = computed(() => {
  if (!hasAvatar.value) {
    return 'radial-gradient(circle at 30% 30%, #FFFFFF 0%, #F3F4F6 100%)';
  }
  const a = props.avatarData || {};
  const c1 = a.topColor || a.hairColor || '#E8EAF6';
  const c2 = a.clothesColor || a.facialHairColor || '#FFFDE7';
  return `radial-gradient(circle at 30% 30%, ${c1}, ${c2})`;
});

const titleText = computed(() => (hasAvatar.value && props.avatarData.isCircle ? 'Круглый аватар' : (hasAvatar.value ? 'Аватар' : 'Темный силуэт')));

function selectAvatar() {
  emit('select', JSON.parse(JSON.stringify(avatarProps.value)));
  emit('update:visible', false);
}

function closePreview() {
  emit('update:visible', false);
  emit('close');
}
</script>

<style scoped>
.avatar-preview {
  width: 100%;
  height: 100%;
}
.avatar-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  overflow: visible;
}
.avatar-background {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: 0;
}
.avatar-component {
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 50%;
  overflow: hidden;
}

/* Стили для силуэта */
.avatar-silhouette {
  z-index: 1;
  width: 64%;
  height: 64%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: visible;
}
.avatar-silhouette svg {
  width: 100%;
  height: 100%;
  fill: #374151; /* тёмно-серый (лучше смотрится на светлом фоне) */
  opacity: 1;
}

/* Basic fade transition */
.fade-enter-active, .fade-leave-active { transition: opacity 200ms ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
